import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DiscoverListsAndLinks } from '@zero/discover/domain';

@Component({
  selector: 'discover-more',
  templateUrl: './discover-more.component.html',
  styleUrls: ['./discover-more.component.scss'],
  imports: [],
})
export class DiscoverMoreComponent {
  @Input() public links: DiscoverListsAndLinks[];

  @Output() public openDetails = new EventEmitter<string>();

  public open(item: DiscoverListsAndLinks): void {
    if (item.link) {
      const url = new URL(item.link);

      const params = new URLSearchParams(url.search);
      params.append('link', 'web');
      url.search = params.toString();

      window.open(`${url.toString()}`, '_blank', 'noopener,noreferrer');
      return;
    }
    this.openDetails.emit(item.id);
  }
}
